import apiRequest, { apiUpload } from './client';

export const updateCompanyProfile = (formData) => apiUpload('/companies/profile/', formData);

export const changeCompanyPassword = (oldPassword, newPassword) =>
  apiRequest('/companies/change-password/', {
    method: 'POST',
    body: { old_password: oldPassword, new_password: newPassword },
  });
